module.exports = __webpack_public_path__ + "static/media/OXIDACION.9981cf8f.png";